import React, {useEffect} from 'react';
import Text from "@/Components/Front/Text";
import * as helpers from '@/Helpers';
import axios from "axios";
import {Link} from "@inertiajs/inertia-react";
import Toggle from "@/Components/Front/Toggle";
import Hamburguer from "@/Components/Front/SVGS/hamburguer";
import Menu from "@/Components/Front/Menu";
import Logo from "@/Components/Front/SVGS/Logo";
import {Link as ScrollLink} from "react-scroll";
import {useMediaQuery} from "react-responsive";
export default function Header({textProps, locale, language, setLang, activeItem, setCurrentActiveSection}) {


    const [menuOpen, setMenuOpen] = React.useState(false);


    const [active, setActive] = React.useState("services-database");

    const isMobile = useMediaQuery({query: '(max-width: 639px)'});
    const isSm = useMediaQuery({query: '(min-width: 640px)'});

    const onLinkActive = (activeItem) => {
    }

    const handleLangChange = () => {

        const headers = new Headers({
            'Content-Type': 'x-www-form-urlencoded',
            'X-CSRF-TOKEN': helpers.getCookie("XSRF-TOKEN"),
        });


        var requestOptions = {
            method: "POST",
            headers,
            credentials: 'include',

        };


        axios(route('lang.switch', {lang: locale === 'en' ? 'es' : 'en'}), requestOptions)
            .then(result => {

                setLang(result.data.lang);

            }).catch((e) => {
            console.log(e)
        })

    };
    useEffect(() => {
        setActive(activeItem);
    }, [activeItem])
    return (
        <header>

            <div className={ menuOpen ? "blocks open" : "blocks"}>
                <span className={"block"}></span>
                <span className={"block"}></span>
                <span className={"block"}></span>
                <span className={"block"}></span>

            </div>


            <Menu  lang={locale} handleLangChange={handleLangChange} textProps={textProps} active={active} open={menuOpen} setMenuOpen={setMenuOpen}/>



            <div className={"box"}/>


            <div className="in-frame">
                {activeItem === "index" ?

                    <ScrollLink activeClass="active" to="hero" spy smooth onSetActive={setCurrentActiveSection}>
                        <Logo/>

                    </ScrollLink>
                    :
                    <Link href={"/"} >
                        <div className="logo">
                            <Logo/>
                            {/*<img src={logo} alt="logo"/>*/}
                        </div>
                    </Link>
                }
                {isMobile &&
                    <div id={"nav-icon"} className={menuOpen ? "open mobile": "mobile"} onClick={()=>{setMenuOpen(!menuOpen)}}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                }
                <nav>
                    <ul>
                        <li className={activeItem === "wwd" ? " active item" : 'item'}>

                            {activeItem==="index" ?

                            <ScrollLink activeClass="active" to="what-we-do" offset={-50} spy smooth onSetActive={setCurrentActiveSection}>
                                <Text {...textProps} str={"what-we-do"}/>

                            </ScrollLink>
                                :
                            <Link href="/#what-we-do">

                                <Text {...textProps} str={"what-we-do"}/>
                            </Link>
                            }
                        </li>

                        <li className={activeItem === "impact" ? " active item" : 'item'}>
                            {activeItem === "index" ?

                                <ScrollLink activeClass="active" to="impact" spy smooth onSetActive={setCurrentActiveSection}>
                                    <Text {...textProps} str={"impact"}/>

                                </ScrollLink>
                                :
                                <Link href="/#impact">

                                    <Text {...textProps} str={"impact"}/>
                                </Link>
                            }
                        </li>
                        <li className={activeItem === "services" ? " active item" : 'item'}>
                            {activeItem === "index" ?

                                <ScrollLink activeClass="active" to="services" offset={0}  spy  smooth onSetActive={setCurrentActiveSection}>
                                    <Text {...textProps} str={"services"}/>

                                </ScrollLink>
                                :
                                <Link href="/#services" className={"active"}>

                                    <Text {...textProps} str={"services"}/>
                                </Link>
                            }
                        </li>
                        <li className={activeItem === "team" ? " active item" : 'item'}>
                            {activeItem === "index" ?

                                <ScrollLink activeClass="active" to="team" spy smooth onSetActive={setCurrentActiveSection}>
                                    <Text {...textProps} str={"team"}/>

                                </ScrollLink>
                                :
                                <Link href="/#team">

                                    <Text {...textProps} str={"team"}/>
                                </Link>
                            }
                        </li>
                        <li className={activeItem === "publications" ? " active item" : 'item'}>
                            {activeItem === "index" ?

                                <ScrollLink activeClass="active" to="publications" spy  smooth onSetActive={setCurrentActiveSection}>
                                    <Text {...textProps} str={"publications"}/>

                                </ScrollLink>
                                :
                                <Link href="/#publications">

                                    <Text {...textProps} str={"publications"}/>
                                </Link>
                            }
                        </li>
                        <li>
                            <Toggle lang={locale} handleLangChange={handleLangChange}/>

                        </li>
                        <li className={"hamb-container"}>
                            <div className={"box"}/>

                            <div id={"nav-icon"} className={menuOpen ? "open": ""} onClick={()=>{setMenuOpen(!menuOpen)}}>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>


                            {/*<Hamburguer onClick={() => {*/}
                            {/*    setMenuOpen(true)*/}
                            {/*}}/>*/}

                        </li>
                    </ul>

                </nav>


            </div>
        </header>
    );
}
